// File: clientapp/src/contexts/AuthContext.js
import React, { createContext, useState, useEffect } from 'react';

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const [user, setUser] = useState(null);
    const [features, setFeatures] = useState([]);
    const [loadingAuth, setLoadingAuth] = useState(true); // New loading flag

    const fetchCurrentUser = async () => {
        try {
            const response = await fetch('/api/account/currentUser', {
                credentials: 'include',
                headers: { 'Content-Type': 'application/json' }
            });
            if (response.ok) {
                const data = await response.json();
                setUser(data);
                setIsAuthenticated(true);
                setFeatures(data.features || []);
            } else {
                setIsAuthenticated(false);
                setUser(null);
                setFeatures([]);
            }
        } catch (error) {
            console.error("Error fetching current user:", error);
            setIsAuthenticated(false);
            setUser(null);
            setFeatures([]);
        } finally {
            setLoadingAuth(false); // Done loading regardless of outcome
        }
    };

    useEffect(() => {
        fetchCurrentUser();
    }, []);

    const login = async () => {
        // After login, re-fetch current user details immediately.
        setLoadingAuth(true);
        await fetchCurrentUser();
    };

    const logout = () => {
        setIsAuthenticated(false);
        setUser(null);
        setFeatures([]);
    };

    return (
        <AuthContext.Provider value={{ isAuthenticated, user, features, loadingAuth, login, logout, fetchCurrentUser }}>
            {children}
        </AuthContext.Provider>
    );
};
